import $ from 'jquery';
import 'select2';                       // globally assign select2 fn to $ element
import 'select2/dist/js/i18n/fr';
import 'select2/dist/css/select2.css';  // optional if you have css loader

export default class Select2 extends HTMLDivElement {

    constructor() {
        super();
        this.select2 = this.querySelector('select');
        this.$select2 = $(this.select2);
    }

    connectedCallback() {
        var options_default = {
            language: 'fr'
        };

        if(this.$select2.data('taggable') == true){
            options_default = this.getTaggableOptions(options_default);
        }

        if(this.$select2.data('ajax') == true){
            options_default = this.getAjaxOptions(options_default);
        }

        this.initSelect2Item(this.$select2, options_default);
    }

    getAjaxOptions(options){
        var ajaxRoute = this.$select2.data('ajax-route');
        var ajaxAttributeId = this.$select2.data('ajax-attr-id') ? this.$select2.data('ajax-attr-id') : 'id';
        var ajaxAttributeText = this.$select2.data('ajax-attr-text') ? this.$select2.data('ajax-attr-text') : 'name';

       return {
           ...options,
           minimumInputLength: 2,
           ajax: {
               delay: 250,
               url: ajaxRoute,
               data: function (params) {
                   return {
                       query: params.term
                   };
               },
               processResults: function (data, params) {
                   var results = [];
                   $.each(data.results, function (id, entity) {
                       results.push({
                           id: entity[ajaxAttributeId],
                           text: entity[ajaxAttributeText]
                       });
                   });
                   return {results: results}
               }
           }

       };
    }

    getTaggableOptions(options){
        return {
            ...options,
            tags: true,
            tokenSeparators: [','],
            createTag: function (params) {
                var term = $.trim(params.term);

                if (term === '') {
                    return null;
                }

                return {
                    id: term,
                    text: term
                };
            }
        };
    }

    configSelect2AllNone($selector, default_options) {
        $.fn.select2.amd.require([
            'select2/utils',
            'select2/dropdown',
            'select2/dropdown/attachBody'
        ], function (Utils, Dropdown, AttachBody) {
            function SelectAll() {
            }

            SelectAll.prototype.render = function (decorated) {
                var $rendered = decorated.call(this);
                var self = this;

                var $selectAll = $('<a/>')
                    .addClass('btn btn-info col-md-6')
                    .text('Tous')
                    .prepend('<i class="ti ti-plus"></i> ');

                var $selectNone = $('<a/>')
                    .addClass('btn btn-danger col-md-6')
                    .text('Aucun')
                    .prepend('<i class="ti ti-x"></i> ');

                var $div = $('<div/>')
                    .addClass('btn-in-select2')
                    .append($selectAll)
                    .append($selectNone);

                var checkOptionsCount = function () {
                    var count = $('.select2-results__option').length;
                    $selectAll.prop('disabled', count > 25);
                };

                var $container = $('.select2-container');
                $container.bind('keyup click', checkOptionsCount);

                var $dropdown = $rendered.find('.select2-dropdown');

                $dropdown.prepend($div);
                $selectAll.on('click', function (e) {
                    $('option', self.$element).prop('selected', true);
                    self.$element.trigger('change');
                    self.trigger('close');
                });

                $selectNone.on('click', function (e) {
                    // Trigger the select event
                    self.$element.val(null);
                    self.$element.trigger('change');
                    self.trigger('close');
                });

                return $rendered;
            };
            var options = $.extend(default_options, {
                dropdownAdapter: Utils.Decorate(
                    Utils.Decorate(
                        Dropdown,
                        AttachBody
                    ),
                    SelectAll
                )
            });
            $selector.select2(options);
        });
    }

    formatSelect2Icon(icon) {
        return $('<a>').addClass('resources').html('<i class="' + icon.text + '"></i> ' + icon.text);
    }

    formatSelect2HtmlOption(option) {
        if ($(option.element).data('htmlOption')) {
            return $.parseHTML($(option.element).data('htmlOption'));
        }

        return option.text;
    }

    initSelect2Item($selector, options) {
        // Check si le parent est une modal
        if($selector.parents('.modal').length)
        {
            options.dropdownParent = $selector.parents('.modal');
        }

        // Check si c'est un selecteur d'icon
        var selectableIcons = $($selector).hasClass('selectable2-icons');
        if(selectableIcons) {
            options = {
                ...options,
                templateSelection: this.formatSelect2Icon,
                templateResult: this.formatSelect2Icon
            }
        }

        var selectableHtmlOption = $($selector).hasClass('selectable2-html-option');
        if(selectableHtmlOption) {
            options = {
                ...options,
                templateSelection: this.formatSelect2HtmlOption,
                templateResult: this.formatSelect2HtmlOption
            }
        }

        // Manage default placeholder
        var placeholder = $selector.data('placeholder');
        if (placeholder !== undefined && placeholder.length > 0) {
            options = $.extend(options, {'placeholder': placeholder});
        }

        options.allowClear = $selector.attr('required') === undefined;

        if ($selector.data('all-none-option')) {
            this.configSelect2AllNone($selector, options);
        } else {
            $selector.select2(options);
        }

        // Is selected items are available in data-selected as array then force them
        var selected = $selector.data('selected');
        if (selected !== undefined && selected.length > 0) {
            $("div" + $selector).select2('data', selected);
        }
    }
}
